module.exports = __webpack_public_path__ + "img/destination_spice.336079d9.jpg";